import { getSlugFromPath } from 'helpers/helpers';
import { getRestrictedRouteSlugsForPages } from 'helpers/routeBuilder';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useSite } from 'selectors/siteSelectors';

/**
 * Custom hook to get the current slug
 * Returns the slug extracted from the current pathname
 */
export function useCurrentSlug(): string | null {
  const location = useLocation();
  return useMemo(() => getSlugFromPath(location.pathname), [location.pathname]);
}

/**
 * Custom hook to check if the current route is restricted
 * Returns true if the current slug is a restricted route
 */
export function useRestrictedRoute(): boolean {
  const location = useLocation();
  const currentSlug = getSlugFromPath(location.pathname);
  const { pages } = useSite();
  const restrictedRouteSlugs = useMemo(
    () => getRestrictedRouteSlugsForPages(pages),
    [pages],
  );

  return useMemo(
    () => currentSlug !== null && restrictedRouteSlugs.includes(currentSlug),
    [currentSlug, restrictedRouteSlugs],
  );
}
